import * as React from 'react';
import { useState } from 'react';
import { Box } from '@mantine/core';
import styled from '@emotion/styled';

import { useIsTabletOrMobileMedia } from '~/hooks';

import { DROPDOWN_LIST } from './constants';
import * as Styles from './index.styled';

const Flex = styled(Box)`
  display: flex;
  height: ${(p) => p.height};
  width: ${(p) => p.width};
  flex-direction: ${(p) => p.flexDirection};
  justify-content: ${(p) => p.justifyContent};
  align-items: ${(p) => p.alignItems};
`;

const DropdownSelectOption = ({ dropdownItem, isActive = false }) => {
  return (
    <Styles.DropdownItemAnchor
      color={dropdownItem.color}
      tabIndex="0"
      href={dropdownItem.url}
      title={dropdownItem.linkTitle}
      target="_blank"
    >
      <Styles.DropdownItemContent>
        <Styles.DropdownItemText isActive={isActive} activeColor={dropdownItem.color}>
          {dropdownItem.heading}
        </Styles.DropdownItemText>
        {dropdownItem.subHeading ? (
          <Styles.DropdownItemSubText>{dropdownItem.subHeading}</Styles.DropdownItemSubText>
        ) : null}
      </Styles.DropdownItemContent>
      {isActive ? <Styles.CheckLogo color={dropdownItem.color} /> : null}
    </Styles.DropdownItemAnchor>
  );
};

const Header = () => {
  const isTablet = useIsTabletOrMobileMedia();
  const [isNavigationMenuOpen, setIsNavigationMenuOpen] = useState(false);

  // let PrimaryCtaBtnComponent = isTablet ? Styles.PrimaryBtn : Styles.OutlineBtn;
  // let primaryCtaBtnProps = {
  //   component: 'a',
  //   href: '/',
  //   title: 'Go to browse candidates',
  // };
  // let primaryCtaBtnChildren = 'Dashboard';
  // const primaryCtaNode = (
  //   <PrimaryCtaBtnComponent {...primaryCtaBtnProps}>{primaryCtaBtnChildren}</PrimaryCtaBtnComponent>
  // );
  const primaryCtaNode = null;

  const toggleNavigationMenuOpen = () => {
    setIsNavigationMenuOpen((prevValue) => !prevValue);
  };

  return (
    <Styles.Root as="header">
      <Styles.HeaderRoot>
        <Styles.Container>
          <Flex alignItems="center" justifyContent="space-between" height="100%">
            <Styles.LogoContainer href="/" title="Upraised">
              <Styles.UpraisedLogo title="Upraised" />
            </Styles.LogoContainer>
            <Styles.NavWrapper>
              {isTablet ? (
                <Box position="relative">
                  <Flex
                    height="40px"
                    width="40px"
                    alignItems="center"
                    justifyContent="center"
                    onClick={toggleNavigationMenuOpen}
                  >
                    <Styles.HamburgerMenuIconContainer
                      isNavigationMenuOpen={isNavigationMenuOpen}
                      className={isNavigationMenuOpen ? 'navigation-menu-open' : ''}
                    >
                      <Styles.HamburgerMenuIconLine className="line-half-start" />
                      <Styles.HamburgerMenuIconLine />
                      <Styles.HamburgerMenuIconLine className="line-half-end" />
                    </Styles.HamburgerMenuIconContainer>
                  </Flex>

                  <Styles.ExtendedMenuContainer showExtendedMenu={isNavigationMenuOpen}>
                    <Styles.MenuContentWrapper>
                      <Styles.MenuNavItemsGroupHeading style={{ marginLeft: '8px' }}>
                        Our Products
                      </Styles.MenuNavItemsGroupHeading>
                      <Styles.MenuNavItemsGrid mt="8px">
                        {DROPDOWN_LIST.PRODUCTS.map((item) => (
                          <DropdownSelectOption dropdownItem={item} key={item.heading} />
                        ))}
                      </Styles.MenuNavItemsGrid>
                      <Styles.MenuNavItemsGroupHeading style={{ marginLeft: '8px', marginTop: '32px' }}>
                        Resources
                      </Styles.MenuNavItemsGroupHeading>
                      <Styles.MenuNavItemsGrid mt="8px">
                        {DROPDOWN_LIST.RESOURCES.map((item) => (
                          <DropdownSelectOption dropdownItem={item} key={item.heading} />
                        ))}
                      </Styles.MenuNavItemsGrid>
                      <Styles.MenuNavItemsGroupHeading style={{ marginLeft: '8px', marginTop: '32px' }}>
                        Impact
                      </Styles.MenuNavItemsGroupHeading>
                      <Styles.MenuNavItemsGrid mt="8px">
                        {DROPDOWN_LIST.IMPACT.map((item) => (
                          <DropdownSelectOption dropdownItem={item} key={item.heading} />
                        ))}
                      </Styles.MenuNavItemsGrid>
                      {/* <Styles.MenuNavItemsGroupHeading style={{ marginLeft: '8px', marginTop: '32px' }}>
                        For Employers
                      </Styles.MenuNavItemsGroupHeading>
                      <Styles.MenuNavItemsGrid mt="8px">
                        {DROPDOWN_LIST.HIRE.map((item) => (
                          <DropdownSelectOption dropdownItem={item} key={item.heading} />
                        ))}
                      </Styles.MenuNavItemsGrid> */}
                      <Box mt="32px">{primaryCtaNode}</Box>
                    </Styles.MenuContentWrapper>
                  </Styles.ExtendedMenuContainer>
                </Box>
              ) : (
                <>
                  <Styles.NavItem>
                    <Styles.NavContentWrapper tabIndex="0">
                      <Styles.NavItemText>Our Products</Styles.NavItemText>
                      <Styles.ChevronDownLogo />
                    </Styles.NavContentWrapper>
                    <Styles.DropdownRoot>
                      {DROPDOWN_LIST.PRODUCTS.map((item) => (
                        <DropdownSelectOption dropdownItem={item} key={item.heading} />
                      ))}
                    </Styles.DropdownRoot>
                  </Styles.NavItem>
                  <Styles.NavItem>
                    <Styles.NavContentWrapper tabIndex="0">
                      <Styles.NavItemText>Resources</Styles.NavItemText>
                      <Styles.ChevronDownLogo />
                    </Styles.NavContentWrapper>
                    <Styles.DropdownRoot>
                      {DROPDOWN_LIST.RESOURCES.map((item) => (
                        <DropdownSelectOption dropdownItem={item} key={item.heading} />
                      ))}
                    </Styles.DropdownRoot>
                  </Styles.NavItem>
                  <Styles.NavItem>
                    <Styles.NavContentWrapper tabIndex="0">
                      <Styles.NavItemText>Impact</Styles.NavItemText>
                      <Styles.ChevronDownLogo />
                    </Styles.NavContentWrapper>
                    <Styles.DropdownRoot>
                      {DROPDOWN_LIST.IMPACT.map((item) => (
                        <DropdownSelectOption dropdownItem={item} key={item.heading} />
                      ))}
                    </Styles.DropdownRoot>
                  </Styles.NavItem>
                  {/* <Styles.NavItem>
                    <Styles.NavContentWrapper tabIndex="0">
                      <Styles.NavItemText>For Employers</Styles.NavItemText>
                      <Styles.ChevronDownLogo />
                    </Styles.NavContentWrapper>
                    <Styles.DropdownRoot>
                      {DROPDOWN_LIST.HIRE.map((item) => (
                        <DropdownSelectOption dropdownItem={item} key={item.heading} />
                      ))}
                    </Styles.DropdownRoot>
                  </Styles.NavItem> */}
                  <Box minWidth="150px" ml="32px">
                    {primaryCtaNode}
                  </Box>
                </>
              )}
            </Styles.NavWrapper>
          </Flex>
        </Styles.Container>
      </Styles.HeaderRoot>
    </Styles.Root>
  );
};

export default Header;
